import Swiper, { Pagination, Navigation, EffectFade } from 'swiper';
function initMenuCulumnsSLider() {
    return new Swiper('.block-menu-columns__swiper', {
        spaceBetween: 32,
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
        },
    });
}
function initSideContentSlider() {
    return new Swiper('.block-side-content-slider__swiper', {
        effect: 'fade',
        loop: true,
        spaceBetween: 32,
        slidesPerView: 1,
        modules: [Navigation, Pagination, EffectFade],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
}
const Sliders = { initMenuCulumnsSLider, initSideContentSlider };
export default Sliders;
